// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5481) return "5481.03e73bdfe691731561dc.css";
	if (chunkId === 5275) return "5275.8179195f535a0fbbe7d9.css";
	// return url for filenames based on template
	return "" + (chunkId === 4402 ? "kindsumNewDetails" : chunkId) + "." + {"1630":"76eda041dac7144b51c1","2296":"22383496310d8e0bd937","2477":"5f3ba7bd875f61d0c9f9","3398":"7cc5860e905af5f675a7","4402":"9b90dd29f123a7daf117","5190":"a1089761426f62b06fda","7189":"3a8562b8be1c694852fe","8421":"1c91cd1e94d4f783b65a"}[chunkId] + ".css";
};